import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import OVERLAYS from '@constants/overlays';
import { SentimentSatisfiedIcon } from '@icons';

import IconPopover from '../../IconPopover';
import ActionsContent from './ActionsContent';
import { ActionsTabs } from './interfaces';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';

const Actions = () => {
  const [activeTab, setActiveTab] = useState<ActionsTabs>(ActionsTabs.Emojis);

  const { t: translate } = useTranslation();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.ACTIONS_BUTTON,
  );

  const handleChangeTab = (_: SyntheticEvent, value: string) => {
    setActiveTab(value as ActionsTabs);
  };

  return (
    <IconPopover
      icon={<SentimentSatisfiedIcon />}
      label={translate('actions.actions')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName="actions"
      overlayName={OVERLAYS.ACTIONS}
      disabled={isDisabledClientSpecific}
    >
      {({ onClose }) => (
        <ActionsContent
          activeTab={activeTab}
          onChangeTab={handleChangeTab}
          onClose={onClose}
        />
      )}
    </IconPopover>
  );
};

export default Actions;
